"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _LineRestriction_viewport, _LineRestriction_dragLineLength, _LineRestriction_dragRay, _LineRestriction_point1, _LineRestriction_point2, _LineRestriction_radius, _LineRestriction_snapRestrictions;
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineRestriction = void 0;
const AbstractRestriction_1 = require("../AbstractRestriction");
const gl_matrix_1 = require("gl-matrix");
// #endregion Type aliases (1)
// #region Classes (1)
class LineRestriction extends AbstractRestriction_1.AbstractRestriction {
    // #endregion Properties (7)
    // #region Constructors (1)
    constructor(viewport, geometryMathManager, parentNode, id, settings, properties) {
        super(viewport, parentNode, id, properties);
        // #region Properties (7)
        _LineRestriction_viewport.set(this, void 0);
        _LineRestriction_dragLineLength.set(this, void 0);
        _LineRestriction_dragRay.set(this, void 0);
        _LineRestriction_point1.set(this, void 0);
        _LineRestriction_point2.set(this, void 0);
        _LineRestriction_radius.set(this, void 0);
        _LineRestriction_snapRestrictions.set(this, {});
        __classPrivateFieldSet(this, _LineRestriction_viewport, viewport, "f");
        __classPrivateFieldSet(this, _LineRestriction_point1, properties.point1, "f");
        __classPrivateFieldSet(this, _LineRestriction_point2, properties.point2, "f");
        __classPrivateFieldSet(this, _LineRestriction_radius, properties.radius || 0, "f");
        const direction = gl_matrix_1.vec3.sub(gl_matrix_1.vec3.create(), __classPrivateFieldGet(this, _LineRestriction_point2, "f"), __classPrivateFieldGet(this, _LineRestriction_point1, "f"));
        __classPrivateFieldSet(this, _LineRestriction_dragLineLength, gl_matrix_1.vec3.length(direction), "f");
        __classPrivateFieldSet(this, _LineRestriction_dragRay, {
            origin: __classPrivateFieldGet(this, _LineRestriction_point1, "f"),
            direction: gl_matrix_1.vec3.divide(gl_matrix_1.vec3.create(), direction, gl_matrix_1.vec3.fromValues(__classPrivateFieldGet(this, _LineRestriction_dragLineLength, "f"), __classPrivateFieldGet(this, _LineRestriction_dragLineLength, "f"), __classPrivateFieldGet(this, _LineRestriction_dragLineLength, "f")))
        }, "f");
    }
    // #endregion Constructors (1)
    // #region Public Getters And Setters (5)
    get point1() {
        return __classPrivateFieldGet(this, _LineRestriction_point1, "f");
    }
    get point2() {
        return __classPrivateFieldGet(this, _LineRestriction_point2, "f");
    }
    get priority() {
        return -1;
    }
    get radius() {
        return __classPrivateFieldGet(this, _LineRestriction_radius, "f");
    }
    get snapRestrictions() {
        return __classPrivateFieldGet(this, _LineRestriction_snapRestrictions, "f");
    }
    // #endregion Public Getters And Setters (5)
    // #region Public Methods (1)
    rayTrace(ray, metaData) {
        const planeNormal = gl_matrix_1.vec3.cross(gl_matrix_1.vec3.create(), ray.direction, __classPrivateFieldGet(this, _LineRestriction_dragRay, "f").direction);
        const Na = gl_matrix_1.vec3.normalize(gl_matrix_1.vec3.create(), gl_matrix_1.vec3.cross(gl_matrix_1.vec3.create(), ray.direction, planeNormal));
        const Nb = gl_matrix_1.vec3.normalize(gl_matrix_1.vec3.create(), gl_matrix_1.vec3.cross(gl_matrix_1.vec3.create(), __classPrivateFieldGet(this, _LineRestriction_dragRay, "f").direction, planeNormal));
        const da = gl_matrix_1.vec3.dot(gl_matrix_1.vec3.sub(gl_matrix_1.vec3.create(), __classPrivateFieldGet(this, _LineRestriction_dragRay, "f").origin, ray.origin), Nb) / gl_matrix_1.vec3.dot(ray.direction, Nb);
        const db = gl_matrix_1.vec3.dot(gl_matrix_1.vec3.sub(gl_matrix_1.vec3.create(), ray.origin, __classPrivateFieldGet(this, _LineRestriction_dragRay, "f").origin), Na) / gl_matrix_1.vec3.dot(__classPrivateFieldGet(this, _LineRestriction_dragRay, "f").direction, Na);
        let pointA = gl_matrix_1.vec3.create();
        if (da < 0) {
            gl_matrix_1.vec3.copy(pointA, ray.origin);
        }
        else {
            pointA = gl_matrix_1.vec3.add(gl_matrix_1.vec3.create(), ray.origin, gl_matrix_1.vec3.mul(gl_matrix_1.vec3.create(), ray.direction, gl_matrix_1.vec3.fromValues(da, da, da)));
        }
        let pointB = gl_matrix_1.vec3.create();
        if (db < 0) {
            gl_matrix_1.vec3.copy(pointB, __classPrivateFieldGet(this, _LineRestriction_dragRay, "f").origin);
        }
        else if (db < __classPrivateFieldGet(this, _LineRestriction_dragLineLength, "f")) {
            pointB = gl_matrix_1.vec3.add(gl_matrix_1.vec3.create(), __classPrivateFieldGet(this, _LineRestriction_dragRay, "f").origin, gl_matrix_1.vec3.mul(gl_matrix_1.vec3.create(), __classPrivateFieldGet(this, _LineRestriction_dragRay, "f").direction, gl_matrix_1.vec3.fromValues(db, db, db)));
        }
        else {
            gl_matrix_1.vec3.copy(pointB, __classPrivateFieldGet(this, _LineRestriction_point2, "f"));
        }
        const distance = gl_matrix_1.vec3.distance(pointA, pointB);
        if (distance < __classPrivateFieldGet(this, _LineRestriction_radius, "f")) {
            return {
                distance,
                point: pointB,
                closestPointOnRay: pointA,
                restriction: this
            };
        }
        return;
    }
    // #endregion Public Methods (1)
    // #region Protected Methods (1)
    visibilityChanged() { }
}
exports.LineRestriction = LineRestriction;
_LineRestriction_viewport = new WeakMap(), _LineRestriction_dragLineLength = new WeakMap(), _LineRestriction_dragRay = new WeakMap(), _LineRestriction_point1 = new WeakMap(), _LineRestriction_point2 = new WeakMap(), _LineRestriction_radius = new WeakMap(), _LineRestriction_snapRestrictions = new WeakMap();
// #endregion Classes (1)
//# sourceMappingURL=LineRestriction.js.map